import { apiGet, apiPost } from './index'
const getProxyMobile = (params) => apiGet('/api/settings/base/proxy/mobile', params)
const getProxyMobileDetails = (proxyId) => apiGet(`/api/settings/base/proxy/mobile/${proxyId}`)
// 文献收藏
const articleUserCollect = (params) => apiPost(`/api/userCollect`, params)
const articleLike = (params) => apiPost(`/api/area/like`, params)
// 取消文献收藏
const articleUnUserCollect = (params) => apiPost(`/api/userCollect/condition/${params.userId}/${params.baseId}/${params.baseType}`)
const articleUnLike = (params) => apiPost(`/api/area/like/condition/${params.userId}/${params.baseId}/${params.type}/${params.kind}`)
// 相关阅读
const getRelatedRead = (params) => apiGet('/api/settings/base/proxy/related/read', params)
// 所属栏目下拉列表
const dictionaryDownList = (params) => apiGet('/api/sys/data/dictionary/drop/down/list', params)

export {
  getProxyMobile,
  getProxyMobileDetails,
  articleUserCollect,
  articleUnUserCollect,
  articleLike,
  articleUnLike,
  getRelatedRead,
  dictionaryDownList,

}



// WEBPACK FOOTER //
// ./src/api/article.js